<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-etas-car-list [listType]="DtgListType.list"></dtg-manage-etas-car-list>
    </div>
</div>